export class AxCounterWithInput {
    private Target: JQuery<HTMLElement>;
    private Options: OptionsCounterInput;

    Init(options: OptionsCounterInput) {
        this.Options = options;
        options.onChange = options.onChange || ((x) => { });
        if (typeof this.Options.incrementValue !== 'number') {
            this.Options.incrementValue = 1;
        }
        this.Target = $(this.Options.target);
        if (this.Target.length > 0) {
            this.Target.addClass('ax-counter-input').addClass('position-relative');

            let minus = document.createElement('div');
            minus.classList.add("ax-btn-transparent");
            minus.classList.add("ax-btn");
            minus.classList.add("ax-color-black");
            minus.style.borderColor = "#fff";
            minus.style.borderBottomLeftRadius = "2px";
            minus.style.borderTopLeftRadius = "2px";
            minus.style.cursor = "pointer";
            let minusChar = document.createTextNode('-');
            minus.appendChild(minusChar);

            let inputContainer = document.createElement('div');
            inputContainer.classList.add("d-flex");
            inputContainer.classList.add("align-items-center");
            let input = $(this.Target)[0].getElementsByTagName('input')[0];
            input.classList.add("ax-counter-input")
            input.setAttribute('type', 'number');

            let additionalText = document.createTextNode(options.text);
            inputContainer.appendChild(input);
            inputContainer.appendChild(additionalText);

            let plus = document.createElement('div');
            plus.classList.add("ax-btn-transparent");
            plus.classList.add("ax-ml-1")
            plus.classList.add("ax-color-black");
            plus.classList.add("ax-btn");
            plus.style.backgroundColor = "#FFE5D6";
            plus.style.borderColor = "#ffe5d6";
            plus.style.borderBottomRightRadius = "2px";
            plus.style.borderTopRightRadius = "2px";
            plus.style.cursor = "pointer";
            let plusChar = document.createTextNode('+');
            plus.appendChild(plusChar);

            let component = document.createElement('div');
            component.classList.add("ax-counter-input-box");
            component.classList.add("d-flex");
            component.append(minus);
            component.append(inputContainer);
            component.append(plus);

            this.Target.append(component);

            let fn = function resizeInput() {

                //disalow decimals
                let old = input.value;
                if (old == "" || old == undefined) {
                    old = "0";
                }
                input.value = String(parseInt(old));

                checkBoundaries();
                //width is wider so that paddings can be applied
                this.style.width = (this.value.length + 1) + "ch";
                options.onChange(parseInt(input.value));
            }
            let incrementFn = function increment() {
                let oldValue: number = parseInt(input.value);
                let newValue: number = oldValue + options.incrementValue;
                input.value = String(newValue);
                options.onChange(newValue);
                fn.call(input);
            }
            plus.addEventListener('click', incrementFn);

            let decrementFn = function decrement() {
                let oldValue: number = parseInt(input.value);
                let newValue: number = oldValue - options.incrementValue;
                input.value = String(newValue)
                options.onChange(newValue);
                fn.call(input);
            }

            let checkBoundaries = function () {
                let amount: number = parseInt(input.value);
                if (typeof options.minValue !== 'undefined' && options.minValue != null) {
                    if (amount < options.minValue) {
                        input.value = String(options.minValue);
                    }
                }
                if (typeof options.maxValue !== 'undefined' && options.maxValue != null) {
                    if (amount > options.maxValue) {
                        input.value = String(options.maxValue);
                    }
                }
            }

            minus.addEventListener('click', decrementFn);
            input.addEventListener('input', fn);
            fn.call(input); // immediately call the function            
        }
    }

    destroy() {
        this.Target.html('');
    }

    public changeAmount(amount: number): void {
        let input = $(this.Target)[0].getElementsByTagName('input')[0];
        input.value = String(amount);
        input.style.width = (input.value.length + 1) + "ch";
    }

    public getAmount(): string {
        let input = $(this.Target)[0].getElementsByTagName('input')[0];
        return input.value;
    }

}

export interface OptionsCounterInput {
    target: string;
    inputValue?: number;
    incrementValue?: number;
    maxValue?: number;
    minValue?: number;
    text: string;
    onChange?: (value: number) => void
}